module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "historyWork clear"
  }, [_c('div', {
    staticClass: "historyHead"
  }, [_c('div', {
    staticClass: "headContent clear"
  }, [_c('span', [_vm._v(_vm._s(_vm.content.workName))])]), _vm._v(" "), _c('div', {
    staticClass: "workName"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/new icon/workName.png"),
      "alt": ""
    },
    on: {
      "mouseenter": _vm.enter,
      "mouseleave": _vm.leave
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showName),
      expression: "showName"
    }],
    staticClass: "down"
  }, [_vm._v(_vm._s(_vm.content.bookName))])]), _vm._v(" "), _c('div', {
    staticClass: "titleAndState"
  }, [_c('div', {
    staticClass: "state",
    class: {
      underway: _vm.content.state == 0, unpublished: _vm.content.state == 1, end: _vm.content.state == -1
    }
  }, [_c('i', {
    staticClass: "point",
    class: {
      underway: _vm.content.state == 0, unpublished: _vm.content.state == 1, end: _vm.content.state == -1
    }
  }), _vm._v("\n        " + _vm._s(_vm.Timetext[_vm.content.state + 1]) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "publishTime"
  }, [(_vm.content.state == 0) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.content.publishDate, 'yyyy-MM-dd W hh:mm')) + " 发布")]) : _vm._e(), _vm._v(" "), (_vm.content.state == -1) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.content.effectiveDate, 'yyyy-MM-dd W hh:mm')) + " 截止")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.content.stateText) + "\n      ")])])]), _vm._v(" "), _c('div', _vm._l((_vm.content.workList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "historyContent"
    }, [_c('div', {
      staticClass: "receiveObj"
    }, [_c('div', [_c('p', {
      attrs: {
        "title": item.reviceObject
      }
    }, [_vm._v(_vm._s(item.reviceObject))])]), _vm._v(" "), (_vm.content.state == 0 || _vm.content.state == -1) ? _c('div', {
      staticClass: "summary",
      on: {
        "click": function($event) {
          _vm.toRank(item, -1, index)
        }
      }
    }, [_vm._v("\n          成绩汇总\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "recall_btn",
      on: {
        "click": function($event) {
          _vm.recall(item, index)
        }
      }
    }, [_c('span', [_vm._v("撤回")])]), _vm._v(" "), (_vm.content.state == 0 || _vm.content.state == -1) ? _c('div', {
      staticClass: "rush_btn",
      on: {
        "click": function($event) {
          _vm.rush(item, index)
        }
      }
    }, [_c('span', [_vm._v("催交")])]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((item.workContents), function(item2, index2) {
      return _c('div', {
        key: index2,
        staticClass: "workContent clear",
        on: {
          "click": function($event) {
            _vm.toRank(item, index2, index)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(item2.resourceName))]), _vm._v(" "), _c('span', [_c('i', {
        staticStyle: {
          "color": "#FF5400"
        }
      }, [_vm._v(_vm._s(item2.submitCount))]), _vm._v("/  " + _vm._s(item.totalNum) + "人 \n            "), _c('i', [_vm._v("完成")])])])
    }))])
  })), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params1,
      "isNotice": _vm.isNotice1
    },
    on: {
      "isConfirm": _vm.isConfirm1
    }
  }), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params2,
      "isNotice": _vm.isNotice2
    },
    on: {
      "isConfirm": _vm.isConfirm2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e047706","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/history.vue
// module id = 1206
// module chunks = 1